import ImageOne from '../../images/interior-1.webp'
import ImageTwo from '../../images/interior-2.webp'

export const InfoData = {
	heading: 'Elevate Your Space with Luxury Furniture',
	paragraphOne: 'Our designers and furniture artisans offer exclusive solutions for your interior. You can expect not only exquisite design but also comfort that will transform your home into a true paradise. Stylish sofas, luxurious tables, and unique accessories – all of this and more is available to you. Discover unique furniture pieces that will bring an unparalleled charm to your interior.',
	paragraphTwo: 'Illuminate your life with our elegant and functional lighting fixtures. We offer a wide range of chandeliers, table lamps, sconces, and lighting solutions for your interior. Our products are designed to bring luxury and coziness to your home.',
	buttonLabel: 'soon',
	image: ImageTwo,
	reverse: false,
	delay: 150
}

export const InfoDataTwo = {
	heading: 'Explore our beautiful 3D models',
	paragraphOne: 'We specialize in crafting high-quality 3D models and unique interior solutions. Our expertise includes working with premium furniture, where each detail is created with love and attention to design.',
	paragraphTwo: 'We invite you to embark on a journey into a realm of endless possibilities for your home and business. Let us bring your vision to life and create an ambiance that delights the eyes and inspires every day.',
	buttonLabel: 'soon',
	image: ImageOne,
	reverse: false,
	delay: 150
}
